import { render } from "./ChildCreationForm.vue?vue&type=template&id=5f652c8a&scoped=true"
import script from "./ChildCreationForm.vue?vue&type=script&lang=js"
export * from "./ChildCreationForm.vue?vue&type=script&lang=js"

import "./ChildCreationForm.vue?vue&type=style&index=0&id=5f652c8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f652c8a"]])

export default __exports__